var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { forwardRef, } from 'react';
import Label from './label';
const RadioGroup = ({ children, className, helpText, label, required, }) => {
    return (_jsxs("fieldset", { className: classNames('mb-3', className), children: [_jsx(Label, { renderAs: "legend", className: "text-reset fs-6", helpText: helpText, required: required, children: label }), children] }));
};
const RadioInput = forwardRef(function RadioInput(_a, ref) {
    var { className, errorMessage, id, label } = _a, props = __rest(_a, ["className", "errorMessage", "id", "label"]);
    return (_jsx("div", { className: classNames('form-check', className), children: _jsxs("label", { className: "form-check-label", htmlFor: id, children: [_jsx("input", Object.assign({ className: "form-check-input", id: id, ref: ref, type: "radio" }, props)), label, errorMessage && (_jsx("div", { className: "invalid-feedback", children: errorMessage }))] }) }));
});
RadioGroup.Input = RadioInput;
export default RadioGroup;
